'use strict'

const baseClass = "CustomContactform";
const forms = document.querySelectorAll("." + baseClass);

function initializeCustomContactform() {
  if (document.readyState !== 'loading') {
    forms.forEach(function (form) {
      new CustomContactform({
        root: form,
      });
    });
  } else {
    document.addEventListener("DOMContentLoaded", (e) => {
      forms.forEach(function (form) {
        new CustomContactform({
          root: form,
        });
      });
    });
  }
}

class CustomContactform {
  constructor(opts) {
    this.root = opts.root;
    this.sections = {
      selectForm: {
        action: selectFormAction,
        container: this.root.querySelector("." + baseClass + "__Container"),
        // container: this.root.querySelector('.' + baseClass + '__SelectForm'),
      },
      selectContact: {
        action: selectContactAction,
        container: this.root.querySelector("." + baseClass + "__Container"),
        // container: this.root.querySelector('.' + baseClass + '__SelectContact'),
      },
      selectFormType: {
        action: selectFormTypeAction,
        container: this.root.querySelector("." + baseClass + "__Container"),
        // container: this.root.querySelector('.' + baseClass + '__SelectFormType'),
      },
      showPhoneContact: {
        action: showPhoneContactAction,
        container: this.root.querySelector("." + baseClass + "__Container"),
        // container: this.root.querySelector('.' + baseClass + '__SelectContact'),
      },
      showForm: {
        action: showFormAction,
        container: this.root.querySelector("." + baseClass + "__Container"),
        // container: this.root.querySelector('.' + baseClass + '__ShowForm'),
      },
      submitForm: {
        action: submitFormAction,
        container: this.root.querySelector("." + baseClass + "__Container"),
        // container: this.root.querySelector('.' + baseClass + '__ShowForm')
      },
    };

    // Initial section
    this.section = "selectForm";

    this.preventDefaultFormAction();

    // Load initial section
    this.loadSection();
  }

  /**
   * Prevent default submit action on all forms
   */
  preventDefaultFormAction() {
    console.log("preventDefaultFormAction");
    this.root.addEventListener("submit", (e) => {
      e.preventDefault();
    });
  }

  /**
   * Apply event on form element to load next section
   *
   * @param {object} el
   * @param {Event} ev
   * @param {object} section
   */
  setCustomFormAction(el, ev, section, customForm) {
    console.log("setCustomFormAction");
    const form = (typeof customForm !== "undefined") ? customForm : el.closest("form");
    console.log({el: el, ev: ev, section: section, form: form});

    // Remove any previous events
    // el.removeEventListener(ev);
    // el.replaceWith(el.cloneNode(true));

    el.addEventListener(ev, (e) => {
      console.log("please load a new section")
      this.loadNewSection(section, form);
    });
  }

  /**
   * Switch to section and load via ajax
   *
   * @param {string} section
   * @param {object} form
   */
  loadNewSection(section, form) {
    console.log("loadNewSection");
    this.section = section;
    this.loadSection(form);
  }

  /**
   * Load section via ajax
   *
   * @param {object} form
   */
  loadSection(form) {
    console.log("loadSection");
    let section = this.sections[this.section];
    let parameters = typeof form !== "undefined" ? new FormData(form) : null;

    fetch(section.action, {
      method: "POST",
      body: parameters,
    })
      .then((response) => {
        return response.text();
      })
      .then((result) => {
        const domResult = new DOMParser().parseFromString(result, "text/html");
        const container = domResult.querySelector("#ContactformAjaxResponse");

        if (typeof container === "undefined" || container === null) {
          alert("Es ist ein Fehler aufgetreten.");
          return;
        }

        section.container.innerHTML = container.innerHTML;

        // Set submit event to next section
        const newFormSubmitElement = section.container.querySelectorAll(
          ".js-customcontactform-submit"
        );
        newFormSubmitElement.forEach((el) => {
          this.setCustomFormAction(
            el,
            el.getAttribute("data-submitevent"),
            el.getAttribute("data-nextsection")
          );
        });

        // Set submit events to previous sections
        var previousFormSubmitElements = section.container.querySelectorAll(
          ".js-customcontactform-back"
        );
        previousFormSubmitElements.forEach((el) => {
          this.setCustomFormAction(
            el,
            "click",
            el.getAttribute("data-section"),
            form
          );
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }
}

export default initializeCustomContactform;
